<div class="container">
  <button type="button" class="text-uppercase close" mat-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div fxLayout="row">
    <h1 mat-dialog-title>Error occurred when merging profiles</h1>
  </div>
  <mat-dialog-content>
    <p *ngFor="let error of data">{{ error }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">OK</button>
  </mat-dialog-actions>
</div>
